import styled from "@emotion/styled";

export const SeparatorMessageWrapper = styled.div`
  position: relative;
  display: flex;
  place-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  color: ${({ theme }) => theme.colors?.tone?.anthraciteLight};

  span {
    display: inline-block;
    padding-inline: ${({ theme }) => theme.space?.space8};
    background-color: ${({ theme }) => theme.colors?.tone?.white};
    z-index: 1;
  }

  &:before {
    content: "";
    position: absolute;
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors?.tone?.silver};
  }
`;
